export const FOLDER_UPLOADS = '/uploads/';
export const FOLDER_ENCODED = '/encoded/';
